var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.appendButtonDisabled')}},[_c('el-switch',{model:{value:(_vm.optionModel.appendButtonDisabled),callback:function ($$v) {_vm.$set(_vm.optionModel, "appendButtonDisabled", $$v)},expression:"optionModel.appendButtonDisabled"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }